module.exports = __webpack_public_path__ + "img/Endangered_Animals_rhino.eb700ed5.png";